import './Projects.css'
import ProjectsList from '../../components/ProjectsList/ProjectsList'

export default function Projects(){
    return (
        <>
            <ProjectsList url='project' /> 
        </>
    )
}